<header class="site-header header-login" id="backtoTop">
        <div class="tal logos-area">
          <div class="onlyMobile login-ayuda-resp">
                <a [routerLink]="['/public/contactpublic']" class="nav-link" href="#">
              <img src="assets/images/icons/ayuda.svg" alt="">
            </a>
          </div>
          <div class="logos-wrap">
                <a [routerLink]="['/public/login']" class="nav-link" href="#">
              <img src="assets/images/LogosOficinas/{{logo}}" class="logo valoriza" alt="{{site}}" />
            </a>
            <a [routerLink]="['/public/login']" class="nav-link" href="#">       
              <img src="assets/images/logo-ov.svg" class="logo oficina" alt="Oficina Virtual"/>
            </a>
          </div>
        </div>
        <div class="idiomas header-login-idiomas onlyMobile">
          <div class="select">
            <select name="slct" class="slct" title="idiomas">
              <option value="0" selected>ES</option>
            </select>
          </div>
        </div>
        <div class="login-top logos-area">
          <div class="idiomas">
            <label for="slct">Idioma</label>
            <div class="select">
              <select name="slct" class="slct">
                <option value="0">Castellano</option>
              </select>
            </div>
          </div>
          <div class="login-ayuda">
            <div class="texto">
              <p>¿Necesitas ayuda?</p>
              <a [routerLink]="['/public/contactpublic']" class="nav-link" href="#">{{titleContact}}</a>
            </div>
            <img src="assets/images/icons/ayuda.svg" alt="">
          </div>
        </div>
      </header>